var main_header = $("#main-header");

function fn_layout_header_appending() {
    main_header.find(".header-wrapper").prepend('<button id="bg"></button>');
    $("#body").prepend('<button id="bgs"></button>');
    $("#body").prepend('<button id="bgd"></button>');
    $("#page").prepend('<button id="bgp"></button>');

    var header_cat_nav = $("#main-nav").html(),
        header_nav = main_header.find(".header-nav");
    header_nav.prepend(header_cat_nav);

    header_nav.on("click","[data-toggle-sub]",function (e) {
        var $el = $(this).parent("a"),
            $sub = $el.next(".sub-nav");

        if($sub.length){
            e.preventDefault();
            $el.closest(header_nav).find(".sub-nav").not($sub).slideUp();
            $el.closest(header_nav).find("[data-toggle-sub]").not($(this)).removeClass("mod--active");
            $(this).toggleClass("mod--active");
            $sub.stop(true, true).slideToggle();
        }
    })
}

function fn_layout__header_layout() {
    var toggle_layout = $(".user-options .icon-layout");
    var title = toggle_layout.attr("title");
    var date = new Date();

    toggle_layout.on("click", function(){
        var data_title = $(this).attr("data-title");
        $("body").toggleClass("big");
        $('.slick-slider').css("opacity",0);
        setTimeout(function(){
            $('.slick-slider').each(function(){
                $(this).css("opacity",1);
                $(this).slick("reinit");
            });
        }, 500);

        if ($("body.big").length) {
            toggle_layout.attr("title", data_title);
            date.setFullYear(date.getFullYear() + 10);
            document.cookie = 'layout-big=1; path=/; expires=' + date.toGMTString();
        } else {
            toggle_layout.attr("title", title);
            date.setFullYear(date.getFullYear() + 10);
            document.cookie = 'layout-big=0; path=/; expires=' + date.toGMTString();
        }
    });
}

function fn_layout__header() {
    $(document).on('click', '#main-header #search .icon-search', function (e) {
        if (main_header.find(".icon-menu").css("display") == "inline-block") {
            if(!$(this).hasClass('active')) {
                e.preventDefault();
            }
            $("body").toggleClass("no-scroll");
            $(this).toggleClass("active").prev().fadeToggle(500).find("input").focus();
            $(this).unbind('click');
            $("#bgs").fadeToggle(300);
        }
    });

    // $(document).on('click', '#main-header .icon-menu', function (e) {
    //     if ($(this).css("display") == "inline-block") {
    //         e.preventDefault();
    //         $("#main-header").addClass("menu-active");
    //         $("#main-header #search .icon-search").removeClass("active").prev().fadeOut(500);
    //         $("#bgs").fadeOut(500);
    //         $("#bg").fadeToggle(300);
    //         $(this).parents("#main-header").find(".header-bar").fadeToggle(300).toggleClass("toggle");
    //         $("body").toggleClass("no-scroll").swipe( {
    //             swipeLeft:function() {
    //                 $("body").removeClass("no-scroll");
    //                 setTimeout(function(){
    //                     $("#main-header").removeClass("menu-active").removeClass("slideDown");
    //                 },500);
    //                 $("#bg").fadeOut(300);
    //                 $("#main-header").find(".header-bar").fadeOut(300).removeClass("toggle");
    //             },
    //             threshold:100,
    //             excludedElements:["a","button"],
    //             fallbackToMouseEvents: false,
    //             preventDefaultEvents: false
    //         });
    //     }
    // });

    $(document).on('click', '#main-header .icon-close, #bg', function () {
        $("body").toggleClass("no-scroll").swipe("destroy");
        setTimeout(function(){
            $("#main-header").removeClass("menu-active").removeClass("slideDown");
        },500);
        $("#bg").fadeToggle(300);
        $("#main-header").find(".header-bar").fadeToggle(300).toggleClass("toggle");
    });

    $(document).on('click', '#bgs', function () {
        $("body").toggleClass("no-scroll");
        $("#bgs").fadeToggle(300);
        $("#main-header #search .icon-search").toggleClass("active").prev().fadeToggle(500);
    });

    if (! $("#layout_nav").length) {
        $("#main-header").after('<nav id="layout_nav" class="ssm-nav"><div class="wrp_nav_head"></div><div class="wrp_nav_content"></div></nav>');

        $.getScript("https://cdnjs.cloudflare.com/ajax/libs/jquery.touchswipe/1.6.19/jquery.touchSwipe.min.js", function() {
            $('.ssm-nav').lui_ssm();
        });

        var layout_nav = $(document).find("#layout_nav"),
            logo = $("#main-header").find(".header-bar .header-heading").html().replace(/h1/g, "span"),
            nav_top = $("#main-nav").html(),
            nav = $("#page").find(".part-aside-nav").clone();

        layout_nav.find(".wrp_nav_head").append(logo);
        layout_nav.find(".wrp_nav_head").append(nav_top);
        layout_nav.find(".wrp_nav_content").append(nav);
    }
}

function eshopDomainConfirm(domainName) {
    $.getScript("//cdnjs.cloudflare.com/ajax/libs/basicModal/3.3.3/basicModal.min.js").done(function () {
        var cookieName = domainName + "_confirm";
        var cookieValue = domainName + "confirm";
        var date = new Date();
        date.setTime(date.getTime() + 6 * 3600 * 1000);
        var text = "<p style='text-align: left'>Důležité upozornění: stránky obsahují sexuální a erotickou tématiku.<br/><br/>Chystáte se vstoupit na stránky, které obsahují sexuální a erotickou tématiku, prosíme, přečtěte si proto pozorně následující podmínky pro vstup a v případě, že s těmito podmínkami budete v plném rozsahu souhlasit, stiskněte tlačítko 'Pokračovat'. V opačném případě stiskněte tlačítko 'Zrušit', nebo odejděte z těchto stránek. <br/<br/>Stisknutím tlačítka 'Pokračovat' potvrzuji, že:<br/><br/>1. je mi více než osmnáct let a že jsem dosáhl/a zletilosti. Pokud se nacházím ve státě, ve kterém je hranice zletilosti stanovena odlišně od předpisů České republiky, potvrzuji, že splňuji veškeré podmínky zletilosti v daném státě a že vstup na tyto stránky není omezen a/nebo zakázán předpisem státu, v němž se aktuálně nacházím a/nebo jehož jsem státním příslušníkem, <br/><br/>2. souhlasím s tím, že sexuálně orientovaný materiál publikovaný na těchto stránkách jsem oprávněn užívat jen v soukromí,<br/><br/>3. sexuálně orientované materiály mne neohrožují, nepohoršují, neurážejí a jsem připraven/a je akceptovat,<br/><br/>4. na tyto stránky vstupuji zcela dobrovolně,<br/><br/>5. neumožním přímo či nepřímo a/nebo aktivně neposkytnu přístup k sexuálně orientovaným materiálům získaným na těchto stránkách osobám, které nesplňují podmínky uvedené v tomto prohlášení. <br/><br/>Stisknutím tlačítka 'Pokračovat' potvrzuji, že v plném rozsahu souhlasím s těmito podmínkami a tyto podmínky v plném rozsahu splňuji.</p>";
        var validate_false = function () {
            document.location = 'http://www.maxisale.cz';
        };
        var validate_true = function () {
            document.cookie = domainName + "=" + cookieValue + ";expires=" + date.toGMTString() + ";path=/;domain=" + domainName + ";";
            basicModal.close();
            return true
        };
        if (document.cookie.indexOf(domainName) < 0) {
            basicModal.show({
                body: text,
                closable: true,
                buttons: {
                    cancel: {
                        title: 'Zrušit',
                        fn: validate_false
                    }, action: {
                        title: 'Pokračovat',
                        fn: validate_true
                    }
                }
            })
        }
    });
}

function advertisementWindow() {
    $.getScript("//cdnjs.cloudflare.com/ajax/libs/basicModal/3.3.3/basicModal.min.js").done(function () {
        basicModal.show({
            body: '<img src="'+$('#advertisementWindow').data('imageadvertisement')+'" ><p>'+$('#advertisementWindow').data('textadvertisement')+'</p><a href="'+$('#advertisementWindow').data('uriadvertisement')+'">Více</a>',
            closable: true,
            buttons: {
                action: {
                    title: $('#advertisementWindow').data('close'),
                    fn: basicModal.close
                }
            }
        })
    });
}
